module.exports = __webpack_public_path__ + "img/9788989056003.9579d38b.jpg";